<div class="container">
    <h1>MECANIZADO DISCO TAMBOR</h1>

   
    <div style="text-align: center;"> <img src="assets/imagenes/tambor1.jpg" width="480" height="360"><img
            src="assets/imagenes/tambor2.jpg" width="480" height="360">
    </div>
</div>